import React from 'react';
import BilingualField from '../../../components/common/BilingualField';

export default function CTAEditor({ content, handleBilingualChange }) {
  return (
    <div className="dash-card mb-4" style={{ maxWidth: 900 }}>
      <h3 className="dash-card-title mb-4">Call to Action (CTA) Section</h3>

      <BilingualField
        label="Overline"
        fieldName="ctaOverline"
        value={content.ctaOverline}
        onChange={handleBilingualChange}
        placeholder="Join ETS Academy Today"
      />

      <div className="form-row-2">
        <BilingualField
          label="Title (Regular Text)"
          fieldName="ctaTitleRegular"
          value={content.ctaTitleRegular}
          onChange={handleBilingualChange}
          isTextarea
          rows={2}
          placeholder="Your Dance Story\nStarts "
        />
        <BilingualField
          label="Title (Italic Text)"
          fieldName="ctaTitleItalic"
          value={content.ctaTitleItalic}
          onChange={handleBilingualChange}
          isTextarea
          rows={2}
          placeholder="Today"
        />
      </div>

      <BilingualField
        label="Subtext"
        fieldName="ctaSubtext"
        value={content.ctaSubtext}
        onChange={handleBilingualChange}
        isTextarea
        rows={3}
      />

      <div className="form-row-2">
        <BilingualField
          label="Primary Button Text"
          fieldName="ctaPrimaryBtnText"
          value={content.ctaPrimaryBtnText}
          onChange={handleBilingualChange}
          placeholder="Start Free Trial →"
        />
        <BilingualField
          label="Secondary Button Text"
          fieldName="ctaSecondaryBtnText"
          value={content.ctaSecondaryBtnText}
          onChange={handleBilingualChange}
          placeholder="Explore Classes"
        />
      </div>

      <BilingualField
        label="Bottom Note"
        fieldName="ctaNote"
        value={content.ctaNote}
        onChange={handleBilingualChange}
        placeholder="14-day free trial · No credit card required · Cancel anytime"
      />
    </div>
  );
}
